import { getPageList } from './startEndPages';
import { getItemText } from './getItemText';

export interface IUsePaginationProps {
  pagesTotal: number;
  page: number;
  paginationWidth: number;
  onSelect(pageSelected: number): void;
}

export const usePagination = (props: IUsePaginationProps) => {
  const { onSelect, page, pagesTotal, paginationWidth } = props;

  const { endPage, pagesList, startPage } = getPageList(page, pagesTotal, paginationWidth);
  const handleNext = page < pagesTotal ? () => onSelect(page + 1) : undefined;
  const handlePrev = page > 1 ? () => onSelect(page - 1) : undefined;
  const getText = (pageNumber: number, itemIndex: number) =>
    getItemText({
      itemIndex,
      pageNumber,
      startPage,
      endPage,
      pagesTotal,
      pagesList,
    });

  return {
    handleNext,
    handlePrev,
    pagesList,
    getText,
  };
};
